import React, {useState} from 'react';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import CustomMultiSelect from "@/Shared/CustomMultiSelect";
import TextInput from "@/Shared/TextInput";
import CategoryForm from "@/Pages/Categories/Assets/CategoryForm";
import LoadingButton from "@/Shared/LoadingButton";

const AddCouponsToCategory = ({id, couponCategories}) => {
  const {categories} = usePage().props;
  const {data, setData, errors, post, processing} = useForm({
    categories: [],
    order: 0,
  });

  function handleSubmit(e) {
    e.preventDefault();
    // post(route('categories.store').url());
  }

  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('categories')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Categories
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>

      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          {/*<CategoryForm errors={errors} data={data} setData={setData} />*/}
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Category
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCouponsToCategory;
